// 명세서 상세 오류 안전망 — 렌더 오류 시 흰 화면 대신 오류 내용 + 돌아가기 표시 (2026-07-25)
import React from 'react';

class StatementErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error('[명세서 상세 오류]', error, info?.componentStack);
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ maxWidth: 560, margin: '60px auto', padding: 24, background: '#fff', border: '1px solid #FECACA', borderRadius: 12, textAlign: 'center' }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>⚠️</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#B91C1C', marginBottom: 8 }}>화면을 표시하는 중 오류가 발생했습니다</div>
                    <div style={{ fontSize: 12.5, color: '#6B7280', background: '#F9FAFB', borderRadius: 8, padding: '10px 12px', marginBottom: 16, wordBreak: 'break-all', textAlign: 'left' }}>
                        {String(this.state.error?.message || this.state.error)}
                    </div>
                    <button onClick={() => { this.setState({ error: null }); this.props.onBack?.(); }}
                        style={{ padding: '10px 20px', border: 'none', borderRadius: 8, background: '#6366F1', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
                        목록으로 돌아가기
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default StatementErrorBoundary;
